// extracted by mini-css-extract-plugin
module.exports = {"container":"auth_container__1dvzZ"};